import Card1 from '@/components/card1icon';
import Card2 from '@/components/card2icon';
import Card3 from '@/components/card3icon';
import Card4 from '@/components/card4icon';
import Card5 from '@/components/card5icon';
import Card6 from '@/components/card6icon';

export const LK = 'https://uae.sahl.tax';

export const navigation = [
  { name: 'About', href: '#about' },
  { name: 'Tools', href: '#tools' },
  { name: 'Pricing', href: '#pricing' },
  { name: 'Docs', href: 'https://docs.sahl.tax' }
];

export const problemsData = [
  {
    title: 'Strict reporting',
    description: ['on income tax and VAT', 'from 2025'],
    Icon: Card1
  },
  {
    title: 'Increased expense',
    description: ['for traditional', 'accounting services'],
    Icon: Card2
  },
  {
    title: 'Higher risk of error',
    description: ['due to manual data entry', 'and the human factor'],
    Icon: Card3
  },
  {
    title: 'Slow and inefficient',
    description: ['data processing'],
    Icon: Card4
  },
  {
    title: 'Reliance on third-party services',
    description: ['for invoice generation', 'complicates the process'],
    Icon: Card5
  },
  {
    title: 'Need to consider specific nuances',
    description: ['such as VAT exemptions for companies', 'with income below 375,000 Dhs.'],
    Icon: Card6
  }
];
